import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/logos/soctio_logo_blue.svg'


const _hoisted_1 = { class: "ps-5 sc-header" }
const _hoisted_2 = ["alt"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSearch = _resolveComponent("HeaderSearch")!
  const _component_HeaderMap = _resolveComponent("HeaderMap")!
  const _component_HeaderUserSpace = _resolveComponent("HeaderUserSpace")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _imports_0,
      alt: _ctx.$t('img.logo')
    }, null, 8, _hoisted_2),
    _createVNode(_component_HeaderSearch),
    _hoisted_3,
    _createVNode(_component_HeaderMap),
    _createVNode(_component_HeaderUserSpace)
  ]))
}